import React from 'react';
import '../Style/Header.css';
import FaceIcon from '@material-ui/icons/Face';

function Header() {
    return (
        <div className="header">
            <h3>Let'sPeak</h3>
            <div className="header_right">
              <p>Become a teacher</p>
              <FaceIcon/>
            </div>
        </div>
         
    )
}

export default Header
